"use strict";
/***************************************************************************
 * Copyright (c) 2021, Voilà contributors                                   *
 * Copyright (c) 2021, QuantStack                                           *
 *                                                                          *
 * Distributed under the terms of the BSD 3-Clause License.                 *
 *                                                                          *
 * The full license is in the file LICENSE, distributed with this software. *
 ****************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedRendererFactories = void 0;
const rendermime_1 = require("@jupyterlab/rendermime");
const javascript_extension_1 = require("@jupyterlab/javascript-extension");
exports.extendedRendererFactories = [
    rendermime_1.htmlRendererFactory,
    rendermime_1.markdownRendererFactory,
    rendermime_1.latexRendererFactory,
    rendermime_1.svgRendererFactory,
    rendermime_1.imageRendererFactory,
    javascript_extension_1.rendererFactory,
    rendermime_1.textRendererFactory
];
//# sourceMappingURL=rendermime.js.map